import { reactive } from 'vue'

// Global alert store
export const alertStore = reactive({
  show: false,
  type: 'info',
  title: '',
  message: '',
  confirmText: 'OK',
  showCancel: false,
  closeOnOverlay: true,
  onConfirm: null,
  onCancel: null
})

// Get default title based on type
const getDefaultTitle = (type) => {
  const titleMap = {
    info: 'Information',
    success: 'Success',
    warning: 'Warning',
    error: 'Error',
    confirm: 'Confirm'
  }
  return titleMap[type] || 'Information'
}

// Show alert
const showAlert = (options) => {
  return new Promise((resolve) => {
    alertStore.show = true
    alertStore.type = options.type || 'info'
    alertStore.title = options.title || getDefaultTitle(options.type)
    alertStore.message = options.message || ''
    alertStore.confirmText = options.confirmText || 'OK'
    alertStore.showCancel = options.showCancel || false
    alertStore.closeOnOverlay = options.closeOnOverlay !== false
    
    alertStore.onConfirm = () => {
      resolve(true)
      alertStore.show = false
    }
    
    alertStore.onCancel = () => {
      resolve(false)
      alertStore.show = false
    }
  })
}

// Convenience methods
export const alert = {
  // Basic alert
  show: (message, type = 'info', title = '') => {
    return showAlert({
      message,
      type,
      title,
      showCancel: false
    })
  },
  
  // Info alert
  info: (message, title = '') => {
    return showAlert({
      message,
      type: 'info',
      title,
      showCancel: false
    })
  },
  
  // Success alert
  success: (message, title = '') => {
    return showAlert({
      message,
      type: 'success',
      title,
      showCancel: false
    })
  },
  
  // Warning alert
  warning: (message, title = '') => {
    return showAlert({
      message,
      type: 'warning',
      title,
      showCancel: false
    })
  },
  
  // Error alert
  error: (message, title = '') => {
    return showAlert({
      message,
      type: 'error',
      title,
      showCancel: false
    })
  },
  
  // Confirm dialog
  confirm: (message, title = '') => {
    return showAlert({
      message,
      type: 'confirm',
      title,
      showCancel: true,
      confirmText: 'Confirm',
      closeOnOverlay: false
    })
  },
  
  // Custom alert with full options
  custom: (options) => {
    return showAlert(options)
  }
}

export default alert